export default __webpack_public_path__ + "img/c00ff711a147a0544e3d3bdd1dca8e26.svg";